import { getData } from '@/shared/api/user';

import { Method } from '../types';
import { type Responder } from './respond-with-message';

export const getDataHandler = async (
  value: any,
  data: { playdeck: any },
  respond: Responder
) => {
  const resolvedKey = value?.key ?? data['playdeck']?.key;

  respond({
    method: Method.GET_DATA,
    value: await getData(resolvedKey),
    key: resolvedKey,
  });
};
